import Vue from 'vue';
import VueDND from 'awe-dnd';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import './element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/font/iconfont.css';
import '@/assets/css/oem.css';
import '@/assets/css/index.css';
import '@/utils/moment.js';
import BaiduMap from 'vue-baidu-map';
// import '@/utils/push.js';
import '@/utils/mqtt.js';
import '@babel/polyfill';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { testMsg } from "@/api";
import removeAria from "./utils/directive";// 引入指令
Vue.directive("removeAria", removeAria);//全局注册
Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)


Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: '4prertsfpMDGf3zw2L0nr7zcPXEIKNZR'
})

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueDND);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

// if (localStorage.testMsg) {
//   const { Realtime, Event } = require('leancloud-realtime');
//   const realtime = new Realtime({
//     appId: 't6y6BMwh8GTIi4GDguJjyrCR-gzGzoHsz',
//     appKey: 'WRRXH1PsyRfJDy3DaSgiX8Om',
//     server: "https://t6y6bmwh.lc-cn-n1-shared.com"
//   });
//   // localStorage.setItem('debug', 'LC*');

//   realtime.createIMClient('tom').then(function (tom) {
//     console.log(tom)
//     tom.on(Event.MESSAGE, function (message, conversation) {
//       console.log('收到新消息：' + message.text + +new Date());
//       testMsg({
//         msg: message.text + +new Date()
//       })
//     });
//   }).catch(console.error);
// }